import React from 'react';
import { useSearchParams } from 'react-router-dom';

import Buscando from 'Component/Buscando';
import Cabecalho from 'Component/Cabecalho';
import { HoleriteLista } from 'Component/Holerite';
import LayoutDefault from 'Component/Layout';
import Paginacao from 'Component/Paginacao';
import SemRegistros from 'Component/SemRegistros';
import { useAppSelector } from 'Store';
import { useRecuperarHoleritesQuery } from 'View/Service/Default/Holerites';

const Historico = (): React.ReactElement => {
  const [searchParams] = useSearchParams();

  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);

  const {
    data: { holerites, paginacao } = {},
    isFetching,
    isLoading,
  } = useRecuperarHoleritesQuery({
    contain: ['VinculosEmpregaticios.Empresas'],
    page: searchParams.get('pagina') || 1,
    options: { usuario_id: usuario?.id },
  });

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Meu histórico de holerites"
        descricao="Veja todos seus holerites aqui"
      />
      <Buscando exibir={isLoading} />
      <SemRegistros carregando={isLoading} registros={holerites?.length} />
      <React.Fragment>
        <div className="bg-white shadow-sm rounded">
          {holerites?.map((relogio) => (
            <HoleriteLista
              key={`${relogio.id}-${relogio.modificado}`}
              dados={relogio}
              btnRemover={false}
              btnAssinar={true}
            />
          ))}
        </div>
      </React.Fragment>
      <Paginacao dados={paginacao} desabilitado={isFetching} />
    </LayoutDefault>
  );
};

export default Historico;
